<div class="page-body-wrapper">
    <div class="row" style="width: 100%;">
        <div class="col-lg-12">
            <!-- Yeni Döküman Butonu -->
            <button mat-raised-button color="primary" class="ms-2" (click)="openNewDocumentModal()" *ngIf="currentUser.hr || currentUser.selectedRole.name === 'ROLE_ADMIN'">
                <mat-icon>add</mat-icon>
                Yeni Döküman
            </button>
            <!-- Arama alanı -->
            <mat-form-field style="width: 100%;">
                <input matInput [(ngModel)]="filterText" (input)="filterTree()" placeholder="Ara...">
            </mat-form-field>

            <!-- Mat Tree -->
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">

                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    <div class="mat-tree-node" [style.padding-left.px]="getLevel(node) * 10">
                        <div class="node-actions" *ngIf="currentUser.hr || currentUser.selectedRole.name === 'ROLE_ADMIN'">
                            <button mat-icon-button color="primary" 
                                    (click)="openEditDocumentModal(node)"
                                    matTooltip="Düzenle"
                                    matTooltipPosition="above">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" 
                                    (click)="deleteDocument(node)"
                                    matTooltip="Sil"
                                    matTooltipPosition="above">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        <button mat-icon-button disabled></button>
                        <mat-icon>{{ node.type === 'folder' ? 'folder' : 'insert_drive_file' }}</mat-icon>
                        <a *ngIf="node.type === 'file' && node.storageDocuments?.length > 0"
                            href="{{fileUploadRootPath}}/{{node.storageDocuments[0]?.filePath}}" target="_blank">
                            {{ node.fileName }} {{ node.fileDescription }}
                        </a>
                        <span *ngIf="node.type === 'folder'">
                          {{ node.fileName }}
                        </span>
                    </div>
                </mat-tree-node>

                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div class="mat-tree-node" [style.padding-left.px]="getLevel(node) * 20">
                        <div class="node-actions" *ngIf="currentUser.hr || currentUser.selectedRole.name === 'ROLE_ADMIN'">
                            <button mat-icon-button color="primary" 
                                    (click)="openEditDocumentModal(node)"
                                    matTooltip="Düzenle"
                                    matTooltipPosition="above">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" 
                                    (click)="deleteDocument(node)"
                                    matTooltip="Sil"
                                    matTooltipPosition="above">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        <button mat-icon-button matTreeNodeToggle>
                            <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                        </button>
                        <mat-icon>folder</mat-icon>
                        {{ node.fileName }}

                    </div>
                    <div *ngIf="treeControl.isExpanded(node)">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>


            </mat-tree>



        </div>
    </div>
</div>